import { AuthModule } from 'ngx-auth';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';

import { AnswerExplanationComponent } from './enhanced-report/answer-explanation/answer-explanation.component';
import { AppRoutingModule } from '../app-routing.module';
import {
  AuthenticationDataService,
  AuthenticationService,
  AuthGuard,
  PermissionsService,
  PublicRedirectGuard
} from './authentication';
import { ConfirmDialogComponent } from './modals/confirm-dialog/confirm-dialog.component';
import { EmptyLayoutComponent } from './layouts/empty-layout/empty-layout.component';
import { EnvironmentService } from './app-constants/environment.service';
import { GuestAccountRequiredGuardComponent } from './modals/guest-account-required-guard/guest-account-required-guard.component';
import { InputDialogComponent } from './modals/input-dialog/input-dialog.component';
import { Logger } from './logger/services/logger.service';
import { QuestionRationaleComponent } from './enhanced-report/question-rationale/question-rationale.component';
import { throwIfAlreadyLoaded } from './module-import-guard';
import { UrlService } from './http/url.service';

import { AppNavigationService, ExternalLinkGuard, RouterService } from './navigation';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { GAMESHOW_REPOSITORY } from './storage/gameshow-repository.interface';
import { KhGameShowStorageService } from './storage/kh-game-show-storage.service';
import { NgxZendeskWebwidgetModule } from './chat/zendesk-webwidget/zendesk-webwidget.module';

import { ToastrModule } from 'ngx-toastr';
import { BaseTranslatableModule } from 'app/core/internationalization/translatable-module';
import { TranslationLoaderHelper } from 'app/core/internationalization/translation-loader-helper';

@NgModule({
  declarations: [
    EmptyLayoutComponent,
    ConfirmDialogComponent,
    InputDialogComponent,
    GuestAccountRequiredGuardComponent,
    AnswerExplanationComponent,
    QuestionRationaleComponent
  ],
  imports: [
    AuthModule,
    AppRoutingModule,
    CommonModule,
    FontAwesomeModule,
    BrowserAnimationsModule,
    SharedModule,
    ToastrModule,
    ModalModule.forRoot(),
    NgxZendeskWebwidgetModule,
    CarouselModule
  ],
  providers: [
    AuthenticationService,
    AuthenticationDataService,
    AuthGuard,
    ExternalLinkGuard,
    Logger,
    RouterService,
    AppNavigationService,
    UrlService,
    PublicRedirectGuard,
    PermissionsService,
    BsModalService,
    EnvironmentService,
    { provide: GAMESHOW_REPOSITORY, useClass: KhGameShowStorageService },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class CoreModule extends BaseTranslatableModule {
  public constructor(
    helper: TranslationLoaderHelper,
    @Optional() @SkipSelf() parentModule: CoreModule
  ) {
    super(helper, 'core');
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
